document.addEventListener('DOMContentLoaded', function () {
  const track = document.getElementById('messages-track');
  const wrapper = document.getElementById('messages-wrapper');
  const prevBtn = document.getElementById('prev-btn');
  const nextBtn = document.getElementById('next-btn');

  let messages = Array.from(track.querySelectorAll('.message-item'));
  const total = messages.length;

  if (total <= 1) {
    prevBtn.style.display = 'none';
    nextBtn.style.display = 'none';
    return;
  }

  // Clone first and last slides
  const firstClone = messages[0].cloneNode(true);
  const lastClone = messages[messages.length - 1].cloneNode(true);
  firstClone.classList.add('clone');
  lastClone.classList.add('clone');
  track.appendChild(firstClone);
  track.insertBefore(lastClone, messages[0]);

  messages = Array.from(track.querySelectorAll('.message-item')); // updated list
  const slideCount = messages.length;
  let current = 1; // Start at first real slide
  let autoSlide;

  // Set widths dynamically
  track.style.width = `${slideCount * 100}%`;
  messages.forEach(slide => {
    slide.style.flex = `0 0 ${100 / slideCount}%`;
  });

  function updateSlide(transition = true) {
    if (!transition) track.style.transition = 'none';
    else track.style.transition = 'transform 0.5s ease';
    track.style.transform = `translateX(-${current * (100 / slideCount)}%)`;
  }

  function slideTo(index) {
    current = index;
    updateSlide(true);
  }

  function showNext() {
    if (current >= slideCount - 1) return;
    current++;
    updateSlide(true);
  }

  function showPrev() {
    if (current <= 0) return;
    current--;
    updateSlide(true);
  }

  function startAutoSlide() {
    autoSlide = setInterval(showNext, 5000);
  }

  function resetAutoSlide() {
    clearInterval(autoSlide);
    startAutoSlide();
  }

  track.addEventListener('transitionend', () => {
    if (messages[current].classList.contains('clone')) {
      if (current === slideCount - 1) {
        current = 1;
      } else if (current === 0) {
        current = slideCount - 2;
      }
      updateSlide(false); // jump instantly
    }
  });

  nextBtn.addEventListener('click', () => {
    showNext();
    resetAutoSlide();
  });

  prevBtn.addEventListener('click', () => {
    showPrev();
    resetAutoSlide();
  });

  // Touch swipe
  let touchStartX = 0;
  let touchEndX = 0;

  wrapper.addEventListener('touchstart', e => {
    touchStartX = e.changedTouches[0].screenX;
  });

  wrapper.addEventListener('touchend', e => {
    touchEndX = e.changedTouches[0].screenX;
    if (touchEndX < touchStartX - 50) {
      showNext();
      resetAutoSlide();
    }
    if (touchEndX > touchStartX + 50) {
      showPrev();
      resetAutoSlide();
    }
  });

  updateSlide(false);
  startAutoSlide();
});